var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}},[_c('circle',{attrs:{"fill":_vm.color.border,"cx":"16","cy":"16","r":"16"}}),_vm._v(" "),_c('g',{domProps:{"innerHTML":_vm._s(_vm.icon.svg.replace('<svg ', `<svg x='6' y='6' fill='#ffffff' width='20' height='20' `))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }